import styled from '@emotion/styled';
import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import loginBG from '../../assets/images/login_back.jpg';
import { createUser } from '../../redux/userStore/actions';
import { UserStateType } from '../../redux/userStore/reducer';
import { ROUTES } from '../../routes';
import { ORANGE, PRIMARY, YELLOW } from '../../shared/colors';
import { checkProfile } from '../shared/ProtectedRoutes';
import { signIn, verify } from './network';

type LayoutType = Parameters<typeof Form>[0]['layout'];

const SignInContainer = styled.div`
  min-height: 100vh;
  background-image: url(${loginBG});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  font-family: Poppins-R;

  .ant-form-item-explain.ant-form-item-explain-error {
    font-size: 11px;
  }

  > div {
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    > div {
      background-color: white;
      width: 300px;
      height: 510px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
        0 6px 20px 0 rgba(0, 0, 0, 0.19);
      padding: 20px;
      border-radius: 35px;
    }
  }

  @media (min-width: 768px) {
    padding: 0px;
    > div {
      > div {
        width: 400px;
      }
    }
  }
`;

export const LoginPage = () => {
  const [form] = Form.useForm();
  const [formLayout] = useState<LayoutType>('vertical');
  const [isLoading, setIsLoading] = useState(false);
  const [isOtp, setisOTP] = useState(false);
  const [runningU, setRunningU] = useState<UserStateType | undefined>();
  const router = useHistory();
  const dispatch = useDispatch();

  const redirectToPage = () => {
    if (runningU) {
      dispatch(createUser(runningU));
      if (checkProfile(runningU.profils as any, 'admin')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'resp_commercial')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'commercial')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'responsable')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'chef_agence')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'gestionnaire')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'sadmin')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      }
    }
  };

  return (
    <SignInContainer>
      <div>
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: 20,
            }}
          >
            <span
              style={{
                fontFamily: 'Poppins-B',
                fontSize: 35,
              }}
            >
              <span style={{ color: ORANGE }}>Moranj</span>
              <span style={{ color: '#6d4c41' }}>E</span>
              <span style={{ color: YELLOW }}>trade</span>
            </span>
          </div>
          <Form
            layout={formLayout}
            form={form}
            labelCol={{ span: 20 }}
            wrapperCol={{ span: 25 }}
            onFinish={async (data) => {
              if (runningU) {
                const { code }: { code: string } = data;
                // if (code === '1234') {
                //   redirectToPage();
                // } else {
                //   notification.error({
                //     message: 'Erreur',
                //     description: 'Code incorrect',
                //   });
                // }
                // return;
                await verify(runningU.email, code)
                  .then(async ({ statusCode, data }) => {
                    if (data.ok) {
                      redirectToPage();
                      // Tu peux rediriger vers une autre page ici
                    } else {
                      setRunningU(undefined);
                      notification.error({
                        message: 'Erreur',
                        description: data.error,
                      });
                    }
                  })
                  .catch((err) => {
                    setRunningU(undefined);
                    notification.error({
                      message: 'Erreur',
                      description: err.message || err,
                    });
                    setIsLoading(false);
                  });
              } else {
                setIsLoading(true);
                const { email, password } = data;
                await signIn(email, password)
                  .then(async ({ statusCode, data }) => {
                    setIsLoading(false);
                    if (statusCode.toString()[0] === '2') {
                      console.log(data);
                      setRunningU({
                        authentifie: true,
                        id: data.id,
                        agence: data.agence,
                        url: data.url,
                        nom: data.nom,
                        prenom: data.prenom,
                        email: data.email,
                        profils: data.profils,
                        manager: data.manager,
                        partenaire: data.partenaire,
                        token: '',
                        nextAuthDate:
                          new Date().getTime() + 12 * 60 * 60 * 1000,
                        achat: 0,
                        vente: 0,
                      });
                      setisOTP(true);
                    } else {
                      notification.error({
                        message: 'Erreur',
                        description: data.message,
                      });
                      setIsLoading(false);
                    }
                  })
                  .catch((err) => {
                    notification.error({
                      message: 'Erreur',
                      description: err.message || err,
                    });
                    setIsLoading(false);
                  });
              }
            }}
          >
            {isOtp ? (
              <>
                <Form.Item
                  label='OTP'
                  name='code'
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Le champ otp est requis',
                    },
                  ]}
                >
                  <Input placeholder='Entrer le code otp reçu par SMS' />
                </Form.Item>
                <Form.Item>
                  <Button
                    type='primary'
                    htmlType='submit'
                    size='large'
                    loading={isLoading}
                    style={{
                      width: '100%',
                      backgroundColor: ORANGE,
                      borderColor: PRIMARY,
                      borderWidth: 0,
                      marginBottom: 20,
                    }}
                  >
                    Verifier
                  </Button>
                </Form.Item>
              </>
            ) : (
              <>
                <Form.Item
                  label='Email'
                  name='email'
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      type: 'email',
                      message: 'Le champ email est requis',
                    },
                  ]}
                >
                  <Input placeholder='adresse mail' type='email' />
                </Form.Item>
                <Form.Item
                  label='Password'
                  name='password'
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Le mot de passe est requis',
                    },
                  ]}
                >
                  <Input.Password placeholder='mot de passe' />
                </Form.Item>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    color: 'red',
                  }}
                >
                  <p
                    style={{
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      fontSize: 12,
                    }}
                  >
                    Mot de passe oublié ?
                  </p>
                </div>

                <Form.Item>
                  <Button
                    type='primary'
                    htmlType='submit'
                    size='large'
                    loading={isLoading}
                    style={{
                      width: '100%',
                      backgroundColor: ORANGE,
                      borderColor: PRIMARY,
                      borderWidth: 0,
                      marginBottom: 20,
                    }}
                  >
                    Connecter
                  </Button>
                </Form.Item>
              </>
            )}
          </Form>
        </div>
      </div>
    </SignInContainer>
  );
};
